import { ref, onMounted, onUnmounted } from 'vue'
import type { Ref } from 'vue'
import type { MenuUser } from '../entities/MenuUser'
import { USER_MENU } from '../entities/MenuType'
import { contentCall } from './useMenu'
import type { AuthUserTypeKeys } from '~~/modules/auth/entities/AuthUser'
import { useUserStore } from '~~/modules/auth/stores/userStore'

export function useMenuUser() {
  const MenuUserInstance: Ref<MenuUser> = ref(null)
  const userStore = useUserStore()

  const unsubscribe = watch(
    () => userStore.state.value.logged,
    () => {
      init()
    },
  )
  onUnmounted(() => {
    unsubscribe()
  })

  // @ts-expect-error -- type mismatch
  const menuAdapter = (rawData, userId): MenuUser => {
    // @ts-expect-error -- type mismatch
    const parsedData: MenuUser = rawData.map(item => {
      return {
        id: item.id,
        name: item.name,
        href: item.href.replace(':id', userId),
      }
    })

    return parsedData
  }

  const init = async () => {
    if (userStore.getLogged.value === true) {
      const data = await contentCall(
        USER_MENU,
        userStore.getUserdata.value.type as AuthUserTypeKeys,
      )
      const dataAdapted = menuAdapter(data, userStore.getUserdata.value.id)
      MenuUserInstance.value = dataAdapted
    }
  }

  onMounted(() => {
    init()
  })

  return { MenuUserInstance }
}
